import { useTraduction } from "../../Contexte/TraductionContext";

function HeroBannerHome() {
    const { contentAccueil } = useTraduction()

    return <>
    <section id="HeroBanner">
        <video src={"../../../Assets/visuels/videos/home/video.webm"} autoPlay loop muted playsInline preload="auto"></video>

        <div className="BlackFilter"></div>

        <div className="containerslogan">
            <img loading="lazy" src={"../../../Assets/visuels/images/logo/isotipo.png"} alt="Logo Renau Transportadors SL"/>
            <p>{contentAccueil.Slogan}</p>
        </div>

        <div className="container containerherobannercontent">
            <h1>{contentAccueil.TitreHeroBanner}</h1>
            <h2 className="mt-12">{contentAccueil.SousTitreHeroBanner}</h2>
            <a href="#Ancre1">
                <button className="btn-medium btn-whiteborder mt-40 ">{contentAccueil.BoutonHeroBanner}</button>
            </a>
            
        </div>
    </section>
    
    </>
}

export default HeroBannerHome